import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import type { IFilterValue, IWidgetProps } from 'widgets/FilterEditor/types/types'
import styles from './styles.module.scss'

export const WidgetLocal = observer(({ filterItem }: IWidgetProps<IFilterValue, string[]>) => {
  const filterValues = Array.isArray(filterItem.payload.value)
    ? filterItem.payload.value
    : filterItem.payload.value !== null
    ? [filterItem.payload.value]
    : []

  const triggerText = () => {
    const key = filterValues[0]

    if (key === 'no_replies') return 'No replies'

    return ''
  }

  const operator = filterItem.operatorKey

  return (
    <>
      <Typography
        variant={'body-md-regular'}
        color={'var(--content-primary-tertiary)'}
        ariaLabel={'WidgetLocal'}
        className={styles.operator}
      >
        {operator}
      </Typography>
      <Typography
        variant={'body-md-regular'}
        color={'var(--content-primary-tertiary)'}
        ariaLabel={'WidgetLocal'}
      >
        {triggerText()}
      </Typography>
    </>
  )
})
